import {
  ADD_QUESTIONNAIRE_SUCCESS,
  POST_QUESTIONNAIRE_DESIGN_SUCCESS,
  RESET_QUESTIONNAIRE,
  GET_QUESTIONNAIRE_LIST_SUCCESS,
  UPDATE_QUESTIONNAIRE_ORDER_SUCCESS,
  DELETE_QUESTIONNAIRE_SUCCESS,
  UPDATE_QUESTIONNAIRE_SUCCESS,
  OPEN_DELETE_QUESTIONNAIRE_MODAL,
  HIDE_DELETE_QUESTIONNAIRE_MODAL,
  GET_QUESTIONNAIRE_SUCCESS,
  RESET_QUESTIONNAIRE_LIST,
  GET_QUESTIONNAIRE_REPLY_SUCCESS,
  RESET_QUESTIONNAIRE_REPLY,
  GET_QUESTIONNAIRE_SCORES_SUCCESS,
  UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS,
  UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED,
  SET_UPDATE_FEATURE_ERROR_MODAL,
  GET_QUESTIONNAIRE,
  GET_QUESTIONNAIRE_FAILED,
  GET_QUESTIONNAIRE_LIST,
  GET_QUESTIONNAIRE_LIST_FAILED,
} from "./actionTypes"

const INIT_STATE = {
  questionnaire: null,
  questionnaireScores: null,
  questionnaireResults: null,
  questionnaireDesign: null,
  questionnaireList: [],
  isDeleteQuestionnaireModalOpen: false,
  questionnaireReply: null,
  updateErrorModalIsOpen: false,
  updateFeatureErrorMessage: "",
  loading: false,
  listLoading: false,
  destroyed: false,
  listDestroyed: false,
}

const Questionnaire = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_QUESTIONNAIRE_SUCCESS:
      if (action.payload.menu_feature) {
        return {
          ...state,
          questionnaire: action.payload,
        }
      } else {
        return state
      }
    case GET_QUESTIONNAIRE:
      return {
        ...state,
        loading: true,
        destroyed: false,
      }
    case GET_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        questionnaireScores: action.payload.scores,
        questionnaireResults: action.payload.results,
        questionnaireDesign: action.payload.design,
        questionnaire: action.payload.questionnaire,
        loading: false,
      }
    case GET_QUESTIONNAIRE_FAILED:
      return {
        ...state,
        loading: false,
      }
    case RESET_QUESTIONNAIRE:
      return {
        ...state,
        questionnaireScores: null,
        questionnaireResults: null,
        questionnaireDesign: null,
        questionnaire: null,
        loading: false,
        destroyed: true,
      }
    case POST_QUESTIONNAIRE_DESIGN_SUCCESS:
      return {
        ...state,
        questionnaireDesign: action.payload,
      }
    case GET_QUESTIONNAIRE_LIST:
      return {
        ...state,
        listLoading: true,
        listDestroyed: false,
      }
    case GET_QUESTIONNAIRE_LIST_SUCCESS:
      return {
        ...state,
        questionnaireList: action.payload,
        listLoading: false,
      }
    case GET_QUESTIONNAIRE_LIST_FAILED:
      return {
        ...state,
        listLoading: false,
      }
    case UPDATE_QUESTIONNAIRE_ORDER_SUCCESS:
    case DELETE_QUESTIONNAIRE_SUCCESS:
      return {
        ...state,
        questionnaireList: action.payload,
      }
    case UPDATE_QUESTIONNAIRE_SUCCESS:
      if (action.payload.length > 0) {
        return {
          ...state,
          questionnaireList: action.payload.map((listItem, index) => ({
            ...listItem,
            order: index + 1,
          })),
        }
      } else {
        return state
      }
    case OPEN_DELETE_QUESTIONNAIRE_MODAL:
      return {
        ...state,
        isDeleteQuestionnaireModalOpen: true,
      }
    case HIDE_DELETE_QUESTIONNAIRE_MODAL:
      return {
        ...state,
        isDeleteQuestionnaireModalOpen: false,
      }
    case RESET_QUESTIONNAIRE_LIST:
      return {
        ...state,
        questionnaireList: [],
        listLoading: false,
        listDestroyed: true,
      }
    case GET_QUESTIONNAIRE_REPLY_SUCCESS:
      return {
        ...state,
        questionnaireReply: action.payload,
      }
    case RESET_QUESTIONNAIRE_REPLY:
      return {
        ...state,
        questionnaireReply: null,
      }
    case GET_QUESTIONNAIRE_SCORES_SUCCESS:
      return {
        ...state,
        questionnaireScores: action.payload,
      }
    case UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS:
      return {
        ...state,
        questionnaireList: action.payload,
      }
    case UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED:
      return {
        ...state,
        updateFeatureErrorMessage: action.payload,
        updateErrorModalIsOpen: true,
      }
    case SET_UPDATE_FEATURE_ERROR_MODAL:
      return {
        ...state,
        updateErrorModalIsOpen: action.payload,
      }
    default:
      return state
  }
}

export default Questionnaire
